const options = {
  behavior: "smooth",
  block: "start",
};

export const scrollToHelper = {
  options,
};
